import { Box, Button, ListItemButton, ListItemIcon, Stack, Typography } from "@mui/material";
import SearchField from "@entrilia/shared/components/inputs/SearchField";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import MetaIcon from "../../../../common/MetaIcon";
import type { CustomFormulaReferenceOption } from "./customColumn.types";

interface Props {
  title?: string;
  fields: CustomFormulaReferenceOption[];
  onSearchChange: (value: string) => void;
  onFieldSelect: (fieldCaption: string) => void;
}

const CustomFormulaColumnsPanel = ({ title = "Columns", fields, onSearchChange, onFieldSelect }: Props) => {
  return (
    <Stack spacing={2} sx={{ p: 2.5, flex: 1, minHeight: 0 }}>
      <Typography variant="subtitle1">{title}</Typography>
      <SearchField fullWidth onSearch={onSearchChange} />
      <ScrollableFlexContainer>
        <Stack spacing={0.5}>
          {fields.map((field) => (
            <ListItemButton
              key={field.guid}
              onClick={() => onFieldSelect(field.caption)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                borderRadius: "4px",
                py: 0.5,
                px: 1,
                minHeight: "2rem",
              }}
            >
              {field.icon !== undefined && (
                <ListItemIcon
                  sx={(theme) => ({
                    minWidth: "20px",
                    justifyContent: "center",
                    color: field.isCustomMeasure ? theme.palette.info.main : theme.palette.secondary.light,
                  })}
                >
                  <MetaIcon icon={field.icon} />
                </ListItemIcon>
              )}
              <Typography variant="body2">{field.caption}</Typography>
              <Button
                variant="text"
                size="small"
                color="secondary"
                sx={{
                  ml: "auto",
                  minWidth: 0,
                  p: 0,
                  fontSize: "12px",
                  "&:hover": { backgroundColor: "transparent" },
                }}
              >
                Add
              </Button>
            </ListItemButton>
          ))}
          {fields.length === 0 && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2" color="textSecondary">
                {`No ${title.toLowerCase()} found`}
              </Typography>
            </Box>
          )}
        </Stack>
      </ScrollableFlexContainer>
    </Stack>
  );
};

export default CustomFormulaColumnsPanel;
